import React from 'react';
import {Link} from "react-router-dom";

import {FAQPageData} from './structuredData.js'
import  { Heading } from '../../components/common/heading.module.js';

import {RtFAQItem} from '../../../server/routes/route-types.js'

interface FAQProps {
	faqs?: RtFAQItem[];
	expanded?: string | number;
}

interface FAQElementProps {
	index: number;
	faq: RtFAQItem;
	exp: boolean;
}

export default function FAQ({faqs, expanded}: FAQProps) {

	if (!faqs || faqs.length === 0) return (<></>);

	let exp: boolean = (expanded !== undefined) && expanded === 1;

	return (
	<>
		<FAQPageData faq={faqs} />

		<section className="section section-sm">
			<div className="container">
				<div className="row row-50">
					<Heading
						heading={"FAQ"}
					/>                       
				</div>
				<div className="row row-50">
					<div className="col"> 
						<div id="accordion">
						{
							faqs.map((faq: RtFAQItem, index: number) =>
								<FAQElement 
									exp={exp}
									key={index}
									index={index}
									faq={faq} 
								/>)
						}
						</div>
					</div>
				</div>
			</div>
		</section>
	</>
	)
}

function FAQElement({index, faq, exp}: FAQElementProps) {

	let expanded: boolean = (exp || (index === 0));

	return (<>
		<div className="card">
			<div className="card-header faq" id={`heading${index}`}>
			<h5 className="mb-0">
				<button 
					className={`btn btn-link ${expanded ? '' : 'collapsed'}`} 
					data-toggle="collapse" 
					data-target={`#collapse${index}`} 
					aria-expanded= {expanded ? 'true' : 'false'}
					aria-controls={`collapse${index}`}
				>
					<b>{faq.questionhtml}</b>
				</button>
			</h5>
			</div>

			<div 
				id={`collapse${index}`} 
				className={`collapse ${expanded ? 'show' : ''}`} 
				aria-labelledby={`heading${index}`} 
				data-parent="#accordion"
			>
				<div className="card-body faq-answer" dangerouslySetInnerHTML={{__html: faq.answerhtml!}}/>         
			</div>
		</div>
	</>)
}
